import React from 'react';
import './blog-post.css';
import prep1 from './pictures/prep1.jpeg';
import prep2 from './pictures/prep2.jpeg';

//import reportWebVitals from './reportWebVitals';

const CTI23 = () => {

  return (
    <div>
      <div className='blog__container'>
        <div className="row">
            <div className="column">
                <header>
                    <h3 className="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>Crack the Interview Event Recap</h2>
                    <p class="site-post-meta">April 18, 2023</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                        On April 16th, WiC hosted our “Crack the Interview” prep event to help students prepare for both 
                        behavioral and technical interviews, along with a guest presentation from an Allen School peer 
                        advisor. It was such an insightful event and we want to thank everyone who came! We learned about 
                        the resources the Allen School provides for the process of applying for internships and completing 
                        interviews. We also practiced answering behavioral questions and walking through technical problems. 
                        All of the attendees found this event very useful and really appreciated the opportunity to work 
                        through interview questions while learning more about the interview process.

                        Thank you once again everyone for coming to the event. We hope you were able to learn new things 
                        while enjoying our event and supporting WiC’s work! 
                    </p>
                    <img src={prep1} alt="Women in Computing officers with Attendees"/>
                    <img src={prep2} alt="practice question completed by attendees"/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default CTI23;